module.exports = __webpack_public_path__ + "static/mobile-00657859980c4b619217650ae3ecdf7f.png";